import HighlightMembership from "./HighlightMembership.component";

export default HighlightMembership;
